<template>
  <div class="voucher__header-container">
    <div class="voucher__header-container__title">
      <label class="voucher__header-container__title-text">
        {{ label }}
      </label>
    </div>
    <div class="voucher__header-container__action">
      <vc-material-icon
        :icon="icon"
        @click="$emit('action')"
      ></vc-material-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  label: string;
  icon: string;
}
defineProps<Props>();
</script>

<style lang="scss">
.voucher {
  font-family: "Plus Jakarta Sans";
  &__header {
    cursor: pointer;
    &-container {
      height: 100%;
      display: grid;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      grid-template-columns: 95% 5%;

      &__title {
        &-text {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: #00341c;
          cursor: pointer;
          text-align: center;
          display: block;
        }
      }

      &__action {
        color: #2e2e2e;
        font-size: 20px;
        height: 20px;
        display: flex;
        width: 20px;
        align-items: center;
      }
    }
  }
}
</style>
